/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_OfficeInputs */

const en_map_office = /** @type {(inputs: Map_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office`)
};

const fr_map_office = /** @type {(inputs: Map_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bureau`)
};

const ms_sg2_map_office = /** @type {(inputs: Map_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pejabat`)
};

/**
* | output |
* | --- |
* | "Office" |
*
* @param {Map_OfficeInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const map_office = /** @type {((inputs?: Map_OfficeInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_OfficeInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_map_office(inputs)
	if (locale === "fr") return fr_map_office(inputs)
	return ms_sg2_map_office(inputs)
});